import type { StateRowValue } from "../backend.d.ts"
import { A } from "@solidjs/router"
import { Component, createMemo } from "solid-js"
import { createMutable } from "solid-js/store"
import createEngineForUI from "../lib/core/engine/createEngineForUI"
import type { Engine } from "../lib/core/engine/Engine.type"
import createSampleEntity from "../lib/core/entity/createSampleEntity"
import { EntityTypeId } from "../lib/core/entity/EntityTypeId.enum"
import findPlayerByProfileId from "../lib/core/player/findPlayerByProfileId"
import { createFirstPlayerIdMemo } from "../rx/memo/createFirstPlayerIdMemo"
import getSessionUserId from "../rx/shared/session/getSessionUserId"
import EngineContext from "./EngineContext"
import SingleEntityIcon3D from "./MapEditor/SingleEntityIcon3D"

interface Props {
  row: StateRowValue
}

const ContinueOrSpectateGameButton: Component<Props> = (props) => {
  const engine: Engine = createMutable<Engine>(createEngineForUI())
  const samplePlayerId = createFirstPlayerIdMemo(engine)
  const stateId = () => props.row.id
  const authInGameText = createMemo(() => {
    if (findPlayerByProfileId(props.row.data, getSessionUserId())) {
      return 'Continue Game'
    }
    return 'Observe Game'
  })

  // bindEngineToComponentV2(engine, canvasRef)

  return (
    <EngineContext.Provider value={engine}>
      <A href={`/game/play?game_id=${stateId()}`}
        class="btn btn-success btn-sm"
        aria-label={authInGameText()}
        title={authInGameText()}
      >
        <SingleEntityIcon3D
          entity={createSampleEntity(EntityTypeId.LightTank, samplePlayerId())}
          size={32}
          style={({ "margin-top": `-48px`, "margin-bottom": `-8px` })}
        />
        {/* {' '}
        <RiDeviceGamepadLine />
        <FaSolidGamepad/>
        <FaSolidPuzzlePiece/>
        <FaSolidCirclePlus/>
        <FaSolidCube/> */}
        {' '}
        {authInGameText()}
      </A>
    </EngineContext.Provider>
  )
}

export default ContinueOrSpectateGameButton